import React from "react";
import styled from "styled-components";

interface Props {
  selected?: boolean;
  onClick?: () => void;

  onMouseDown?: (e: React.MouseEvent) => void;
  onMouseUp?: (e: React.MouseEvent) => void;
  onMouseEnter?: (e: React.MouseEvent) => void;

  onTouchStart?: (e: React.TouchEvent) => void;
}

const Cell = styled.div<Props>`
  width: 4.5rem;
  height: 4.5rem;
  border-left: solid 1.25px #333;
  cursor: pointer;
  transition: background-color 0.2s;

  &:first-child {
    border-left: none;
  }
  // disable drag-to-scroll on touch devices
  // so that we can use touch events for selection
  touch-action: none;

  ${(props) => {
    if (props.selected) {
      return `
          background-color: #6DC4EC;
        `;
    } else {
      return `
          background-color: #e7e7e7;
          &:hover {
            background-color: #ddd;
          }
        `;
    }
  }}
`;

const FractionModelCell: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <Cell {...props} aria-checked={props.selected}></Cell>;
};

export default FractionModelCell;
